import { render, staticRenderFns } from "./AddPriceModal.vue?vue&type=template&id=1857017a&"
import script from "./AddPriceModal.vue?vue&type=script&lang=js&"
export * from "./AddPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPriceModal.vue?vue&type=style&index=0&id=1857017a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports